import { ContactCompanies } from './orionContactCompany';
export class Gdpr {
  contactId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  isResearched: boolean;
  responseMessage: string;
  gdprStatus: string;
  contactCompanies: ContactCompanies[];
}





